var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsights(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#insights_svg__clip0_202_9726)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 8.153c-1.39 0-2.166 1.38-1.85 2.405l-3.402 3.412a1.953 1.953 0 00-.996 0l-2.444-2.444c.326-1.025-.45-2.415-1.85-2.415-1.39 0-2.175 1.38-1.85 2.415l-4.37 4.36c-1.025-.316-2.405.46-2.405 1.85 0 1.054.863 1.917 1.917 1.917 1.39 0 2.166-1.38 1.85-2.406l4.36-4.37c.287.087.71.087.997 0l2.443 2.444c-.325 1.026.45 2.415 1.85 2.415 1.39 0 2.175-1.38 1.85-2.415l3.411-3.402c1.026.316 2.406-.46 2.406-1.85a1.922 1.922 0 00-1.917-1.916z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 9.111l.9-1.984 1.975-.89-1.974-.892-.901-1.984-.882 1.984-1.993.891 1.993.891.882 1.984zM3.354 11.028l.48-1.917 1.916-.48-1.917-.478-.479-1.917-.48 1.917-1.916.479 1.917.48.48 1.916z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "insights_svg__clip0_202_9726"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .486)",
    d: "M0 0h23v23H0z"
  })))));
}
export default SvgInsights;